import type { TextBlockProps } from './types'

export default function TextBlock({ items = [] }: TextBlockProps) {
	return (
		<div className="flex flex-col gap-12 my-12">
			{items.map((item, i) => (
				<section key={i}>
					<div className="container">
						<div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-start">
							{item.isHeadingSided && item.title ? (
								<div className="lg:col-span-5 xl:col-span-4">
									<h2 className="h3 text-black-950">{item.title}</h2>
								</div>
							) : (
								<div className="hidden lg:col-span-5 lg:block xl:col-span-4" aria-hidden="true" />
							)}
							<div className="lg:col-span-6 xl:col-span-7 max-w-200">
								{!item.isHeadingSided && item.title && (
									<h3 className="h3 text-black-950 mb-8">{item.title}</h3>
								)}
								{typeof item.text === 'string' ? (
									<div
										className="rich-text"
										dangerouslySetInnerHTML={{ __html: item.text }}
										suppressHydrationWarning
									/>
								) : (
									<div className="rich-text">{item.text}</div>
								)}
							</div>
						</div>
					</div>
				</section>
			))}
		</div>
	)
}
